import { E2eModule } from '../app/e2e.module';

const env = {
    production: true,
    env: 'test',
    ROOT_URL: 'https://dev-kaskade.nonprod.k8s.eon.com',
    API_URL: '/api',
    ASSET_URL: '/assets',
    envModules: [
        E2eModule,
    ],
    oauth: {
        redirectUrl: window.location.origin + window.location.pathname,
        loginUrl: 'https://westnetz-tnb-portal-dev.eon-ciam-dev.auth0app.com/authorize' +
            '?response_type=code' +
            '&client_id=m0TVGAa4usHBS9QDDjl7HoTZDUjQVei2' +
            '&scope=offline_access' +
            '&audience=urn:westnetz:tnbportal:kaskade:backend:dev' +
            '&redirect_uri=https://dev-kaskade.nonprod.k8s.eon.com',
        logoutUrl: 'https://westnetz-tnb-portal-dev.eon-ciam-dev.auth0app.com/v2/logout' +
            '?client_id=m0TVGAa4usHBS9QDDjl7HoTZDUjQVei2' +
            '&returnTo=https://dev-kaskade.nonprod.k8s.eon.com',
    },
};

export const environment = env;
